import {BehaviorSubject, Observable} from 'rxjs';

export abstract class ThreadsViewModel<State extends object> {
  private _state$: BehaviorSubject<State>;

  constructor(initialState: State) {
    this._state$ = new BehaviorSubject(initialState);
  }

  get state(): State {
    return this._state$.getValue();
  }

  stateObservable(): Observable<State> {
    return this._state$.asObservable();
  }

  protected setState(update: Partial<State> | ((state: State) => State)) {
    const next =
      typeof update === 'function'
        ? update(this.state)
        : {...this.state, ...update};

    this._state$.next(next);
  }
}
